import React from 'react'
import { useSelector } from 'react-redux'
const withDealer = Component => props => {
    const dealer = useSelector(state => state.dealer)
    return (
        <Component {...props} dealer={dealer} />
    )
}

export default withDealer